var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LightboxContentLayout',{attrs:{"accessibilityText":_vm.data.accessibility_text,"ariaDescription":undefined,"captionText":_vm.data.caption,"accessibilityTextFlag":false}},[_c('div',{staticClass:"full-screen",attrs:{"id":_vm.uniqueDivId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }